import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TThunkAction } from '../../types/redux';
import { EFiltersActionTypes, TSetRegion } from './types';
import { TFilterRegion } from '../../types/filters';
import { getPeriods } from '../options/getPeriods';
import { findLastMonth } from '../../../regions/containers/PeriodContainer/helpers';
import { setCurrentDate } from './setCurrentDate';

export const setRegion: (region: TFilterRegion) => TSetRegion = actionGenerator<
  EFiltersActionTypes.SetRegion,
  TFilterRegion
>(EFiltersActionTypes.SetRegion);

export function setCurrentRegion(region: TFilterRegion): TThunkAction {
  return (dispatch, getState) => {
    dispatch(setRegion(region));

    dispatch(getPeriods());

    const { options } = getState();

    dispatch(setCurrentDate(findLastMonth(options.options)));
  };
}
